import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';

class TouchBlocker extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      active: true,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.windowHasFocus && nextProps.windowHasFocus) {
      this.setState({
        active: true,
      });
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  @autobind
  onClick() {
    if (this.props.deactivateOnClick) {
      this.setState({
        active: false,
      });
    }
  }

  render() {
    const {
      component: Component,
      children,
      enabled,
      deactivateOnClick,
      ...props
    } = this.props;

    const transparentOverlayStyles = {
      position: 'absolute',
      left: '0',
      top: '0',
      right: '0',
      bottom: '0',
      zIndex: '1',
      cursor: 'pointer',
    };

    return (
      <Component style={props.style}>
        {children}
        {enabled && this.state.active && (
          <div style={transparentOverlayStyles} onClick={this.onClick} />
        )}
      </Component>
    );
  }
}

TouchBlocker.propTypes = {
  component: PropTypes.string,
  enabled: PropTypes.bool,
  deactivateOnClick: PropTypes.bool,
  windowHasFocus: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

TouchBlocker.defaultProps = {
  component: 'div',
  enabled: true,
  deactivateOnClick: true,
};

export default TouchBlocker;
